import React, { useState, useRef } from 'react';
import { Search, Filter, Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FilterDropdown } from '../components/FilterDropdown';
const users = [{
  id: 1,
  name: 'Ana Silva',
  email: 'ana.silva@email.com',
  method: 'Email',
  registered: '15/01/2024',
  lastAccess: 'Há 2 horas',
  status: 'active'
}, {
  id: 2,
  name: 'Carlos Santos',
  email: 'carlos@email.com',
  method: 'Google',
  registered: '12/01/2024',
  lastAccess: 'Há 1 dia',
  status: 'active'
}, {
  id: 3,
  name: 'Maria Oliveira',
  email: 'maria.o@email.com',
  method: 'Email',
  registered: '08/01/2024',
  lastAccess: 'Há 5 dias',
  status: 'inactive'
}, {
  id: 4,
  name: 'João Pedro',
  email: 'joao.p@email.com',
  method: 'Google',
  registered: '05/01/2024',
  lastAccess: 'Há 3 horas',
  status: 'active'
}, {
  id: 5,
  name: 'Fernanda Costa',
  email: 'fernanda@email.com',
  method: 'Email',
  registered: '02/01/2024',
  lastAccess: 'Há 2 dias',
  status: 'active'
}];
export function Users() {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [methodFilter, setMethodFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [dateRange, setDateRange] = useState({
    start: '',
    end: ''
  });
  const filterButtonRef = useRef<HTMLButtonElement>(null);
  const handleApplyFilters = () => {
    setIsFilterOpen(false);
  };
  const handleClearFilters = () => {
    setMethodFilter('all');
    setStatusFilter('all');
    setDateRange({
      start: '',
      end: ''
    });
  };
  const activeFiltersCount = [methodFilter !== 'all', statusFilter !== 'all', dateRange.start || dateRange.end].filter(Boolean).length;
  return <div className="space-y-6" data-id="element-587">
      <div className="flex items-center justify-between" data-id="element-588">
        <div data-id="element-589">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-590">Usuários</h1>
          <p className="text-gray-600 mt-1" data-id="element-591">
            Gerencie todos os usuários do iDreamy
          </p>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-592">
        <div className="p-6 border-b border-gray-200" data-id="element-593">
          <div className="flex items-center gap-4" data-id="element-594">
            <div className="flex-1 relative" data-id="element-595">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-596" />
              <input type="text" placeholder="Buscar por nome ou e-mail..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-597" />
            </div>
            <div className="relative" data-id="element-598">
              <button ref={filterButtonRef} onClick={() => setIsFilterOpen(!isFilterOpen)} className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors relative" data-id="element-599">
                <Filter className="w-5 h-5" data-id="element-600" />
                Filtros
                {activeFiltersCount > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#8BC4C3] text-white text-xs font-bold rounded-full flex items-center justify-center" data-id="element-601">
                    {activeFiltersCount}
                  </span>}
              </button>
              <FilterDropdown isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} onApply={handleApplyFilters} onClear={handleClearFilters} triggerRef={filterButtonRef} data-id="element-602">
                <div className="space-y-4" data-id="element-603">
                  <div data-id="element-604">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-605">
                      Método de Login
                    </label>
                    <select value={methodFilter} onChange={e => setMethodFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-606">
                      <option value="all" data-id="element-607">Todos</option>
                      <option value="email" data-id="element-608">Email</option>
                      <option value="google" data-id="element-609">Google</option>
                    </select>
                  </div>
                  <div data-id="element-610">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-611">
                      Status
                    </label>
                    <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-612">
                      <option value="all" data-id="element-613">Todos</option>
                      <option value="active" data-id="element-614">Ativo</option>
                      <option value="inactive" data-id="element-615">Inativo</option>
                    </select>
                  </div>
                  <div data-id="element-616">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-617">
                      Data de Registro
                    </label>
                    <div className="space-y-2" data-id="element-618">
                      <input type="date" value={dateRange.start} onChange={e => setDateRange({
                      ...dateRange,
                      start: e.target.value
                    })} placeholder="Created from" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-619" />
                      <input type="date" value={dateRange.end} onChange={e => setDateRange({
                      ...dateRange,
                      end: e.target.value
                    })} placeholder="Created until" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#8BC4C3] focus:border-transparent" data-id="element-620" />
                    </div>
                  </div>
                </div>
              </FilterDropdown>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-621">
          <table className="w-full" data-id="element-622">
            <thead className="bg-gray-50 border-b border-gray-200" data-id="element-623">
              <tr data-id="element-624">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-625">
                  Nome
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-626">
                  E-mail
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-627">
                  Método
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-628">
                  Data de Registro
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-629">
                  Último Acesso
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-630">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-631">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-632">
              {users.map(user => <tr key={user.id} className="hover:bg-gray-50 transition-colors" data-id="element-633">
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-634">
                    <div className="flex items-center gap-3" data-id="element-635">
                      <div className="w-8 h-8 bg-gradient-to-br from-[#8BC4C3] to-[#2C4A6B] rounded-full flex items-center justify-center text-white text-sm font-semibold" data-id="element-636">
                        {user.name.charAt(0)}
                      </div>
                      <span className="text-sm font-medium text-gray-900" data-id="element-637">
                        {user.name}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-638">
                    {user.email}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-639">
                    <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-700 rounded" data-id="element-640">
                      {user.method}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-641">
                    {user.registered}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-600" data-id="element-642">
                    {user.lastAccess}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-643">
                    <span className={`px-2 py-1 text-xs font-medium rounded ${user.status === 'active' ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`} data-id="element-644">
                      {user.status === 'active' ? 'Ativo' : 'Inativo'}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-645">
                    <Link to={`/users/${user.id}`} className="p-1.5 text-[#2C4A6B] hover:bg-[#E8F4F4] rounded transition-colors inline-block" title="Visualizar" data-id="element-646">
                      <Eye className="w-4 h-4" data-id="element-647" />
                    </Link>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-648">
          <p className="text-sm text-gray-600" data-id="element-649">
            Mostrando 1 a 5 de 5.234 usuários
          </p>
          <div className="flex gap-2" data-id="element-650">
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-651">
              Anterior
            </button>
            <button className="px-3 py-1.5 text-sm bg-[#8BC4C3] text-white rounded-lg" data-id="element-652">
              1
            </button>
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-653">
              2
            </button>
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-654">
              3
            </button>
            <button className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-655">
              Próximo
            </button>
          </div>
        </div>
      </div>
    </div>;
}